import React from "react";

const Input = (props) => {
  return (
    <div className={`input_group ${props.inputGroupClass}`}>
      {props.label && <label htmlFor={props.label}>{props.label}</label>}
      <input
        type={props.type}
        name={props.name}
        className={props.className}
        placeholder={props.placeholder}
        id={props.id}
        value={props.value}
        style={props.style}
        onChange={props.onChange}
        disabled={props.disabled}
        ref={props.ref}
      />
    </div>
  );
};

export default Input;
